export default "__VITE_ASSET__6fAszM0V__"